export const workHistory = [
    {
        title: "Software Engineer",
        company: "Rodinia Generation, Copenhagen",
        dates: "May 2021 - Sep 2025",
        description: [
            "Developed backend services for automated production using Django, Celery, WebSockets, and MQTT, enabling real-time machine communication.",
            "Used SvelteKit (JavaScript/TypeScript) for frontend and SVG processing on the client side.",
            "Built a fabric/ink inventory tracking module, with real-time updates and transaction history.",
            "Processed incoming hardware data to update production object states and pushed real-time frontend updates via WebSockets.",
            "Built an SVG processing workflow validating, parsing, and extracting components with lxml in Celery tasks, coupled with real-time UI updates.",
            "Integrated an external Docker-based nesting algorithm for SVG placement based on user selections, with progress tracking via Django signals.",
            "Designed a message-driven architecture using Redis pub/sub and a Node.js service to coordinate secure token-based interactions and trigger SVG regeneration.",
            "Maintained a long-running MQTT listener service for real-time machine-to-server request-response messaging and production metadata lookup.",
            "Deployed and maintained system components on on-premises servers using a self-hosted GitHub Actions runner to support continuous delivery in air-gaped environments.",
            "Participated and facilitated sprint planning and fostered cross-functional collaboration to align on requirements and project goals."
        ]
    },
    {
        title: "Software Developer",
        company: "Self Employed, Copenhagen",
        dates: "Jan 2020 – May 2021",
        description: [
            "Contributed as a developer and project manager for Smart Developers project.",
            "Used Git, GitHub and project boards (e.g., Trello/Jira) for task tracking and collaboration.",
            "Freelance Software Developer (Projects: Smart Developers, mobiletilbud and few other smaller projects).",
            "Technologies: Python, Django, React, Celery, Web scraping."
        ]
    },
    {
        title: "Python/Django Developer (Part-Time)",
        company: "Ticketbutler, Copenhagen",
        dates: "May 2018 – Dec 2018",
        description: [
            "Developed Waiting list, SMS and email notifications feature among others.",
            "Worked with debugging, bug fixes and software maintenance.",
            "Worked across both backend (Django REST Framework, PostgreSQL) and frontend (React) code base."
        ]
    },
    {
        title: "Software Engineer & Project Coordinator",
        company: "Korgix, Lahore",
        dates: "Mar 2014 – Aug 2014",
        description: [
            "Delivered Java-based desktop and mobile applications for two small businesses.",
            "Communicated directly with clients to gather requirements and provide ongoing support.",
            "Planned and managed project tasks, timelines, and priorities.",
            "Supervised interns and reviewed their code contributions.",
            "Conducted training sessions for clients and end-users to ensure successful system adoption."
        ]
    },
    {
        title: "Java Developer (Intern)",
        company: "Simus Systems GmbH, Karlsruhe",
        dates: "Aug 2011 – July 2012",
        description: [
            "Worked on a Java desktop application using Java SE 6, Swing, and JDBC.",
            "Rapidly learned Java and contributed to production code.",
            "Gained hands-on experience with SIMUS Systems' data management and engineering optimization software (classmate).",
            "Developed new features, fixed bugs and improved software functionality.",
            "Collaborated with the development team to troubleshoot and debug technical issues."
        ]
    }
];
